import React, { useState, useEffect } from "react";
import { db, auth } from "./firebase";
import { collection, getDocs, query, where, updateDoc, doc, getDoc } from "firebase/firestore";
import { handleLoginAccess } from './Utility/handleLoginAccess';

const ActivateCode = () => {
  const [codeInput, setCodeInput] = useState("");
  const [message, setMessage] = useState("");
  const [user, setUser] = useState(null); // To store the current user

  useEffect(() => {
    // Check if a user is logged in
    const unsubscribe = auth.onAuthStateChanged((user) => {
      setUser(user); // Update the user state if logged in
    });

    return () => unsubscribe(); // Cleanup on unmount
  }, []);

  const handleActivateCode = async () => {
    if (!user) {
      setMessage("Musisz być zalogowany, aby aktywować kod.");
      return;
    }

    if (codeInput.trim() === "") {
      setMessage("Wprowadź kod aktywacyjny.");
      return;
    }

    try {
      const trimmedCode = codeInput.trim();
      const q = query(
        collection(db, "accesCodes"),
        where("code", "==", trimmedCode)
      );
      const querySnapshot = await getDocs(q);

      if (!querySnapshot.empty) {
        const docData = querySnapshot.docs[0].data();
        const docRef = querySnapshot.docs[0].ref;
        const usedStatus = docData.used;

        if (usedStatus) {
          setMessage("Kod został już wykorzystany.");
        } else {
          // Save the code to the user's document in the Users collection
          const userDocRef = doc(db, "Users", user.uid);
          const userDoc = await getDoc(userDocRef);

          if (userDoc.exists()) {
            await updateDoc(userDocRef, { activationCode: trimmedCode });
            await updateDoc(docRef, { used: true });
            setMessage("Kod aktywowany pomyślnie! W przeciągu 24h dostęp zostanie przyznany.");
          } else {
            setMessage("Brak dokumentu użytkownika.");
          }
        }
      } else {
        setMessage("Nieprawidłowy kod.");
      }
    } catch (error) {
      console.error("Błąd przy aktywacji kodu:", error);
      setMessage("Wystąpił błąd podczas próby aktywacji kodu.");
    }
  };

  if (!user) {
    return handleLoginAccess();  // użycie wspólnej funkcji
  }

  return (
    <>
    <div className="wrapper">
 <h1>Aktywacja Kodów Dostępu</h1>
 <div className="input-box">
 <input
        type="text"
        placeholder="Wprowadź kod"
        value={codeInput}
        onChange={(e) => setCodeInput(e.target.value)}
      /></div>
      <br/>
 <button onClick={handleActivateCode}>Aktywuj</button>
 
 <p style={{ display: "flex", justifyContent: "center" }}><br/>{message}</p>
 <br/>
 <a href="/home">
        <button>Wejdź do AI</button>
      </a>
      <br/>
      <br/>
      <br/>
 <a href="/profile">
        <button>Powrót</button>
      </a>
     </div>
     <br/>
     <div className="wrapper">
     <p style={{ fontSize: "12px", marginBottom: "4px" }} >Jeżeli jeszcze nie masz dostępu do pakietu DragonscapeAI, to nie błąd ani koniec świata!</p>
     <p style={{ fontSize: "12px", marginBottom: "4px" }} >Pamiętaj, że nawet jeśli zarejestrowałeś swój kod, z reguły aktywacja wymaga oczekiwania do 24 godzin.</p>
     <p style={{ fontSize: "12px" }}>Jeżeli czas upłynął, a wciąż nie masz dostępu, skontaktuj się z nami <a href="/kontakt">tutaj</a> i dokładnie opisz szytuację</p>
     </div>
     </>
  );
};

export default ActivateCode;